import React, { FC } from 'react';
import { AppIcon as AppIconComponent, AppIconProps as AppIconComponentProps } from '@adjust/dashboard-components';

interface AppIconProps extends AppIconComponentProps {
  appId: string;
}

const DEMO_ENVIRONMENT = 'demo';
const DEFAULT_APP_ICON = '/assets/images/demo-app-icon.svg';

const isDemoEnv = () => configurationURL.environment.startsWith(DEMO_ENVIRONMENT);

const getAppIconUrl = (appId: string) => `${configurationURL.apptrace.baseUrl}/app/${appId}/artwork_url_small`;

const getImageUrl = (appId: string) => (isDemoEnv() ? DEFAULT_APP_ICON : getAppIconUrl(appId));

export const AppIcon: FC<AppIconProps> = ({ appId, ...restProps }) => (
  <AppIconComponent imageUrl={getImageUrl(appId)} {...restProps} />
);
